module.exports = __webpack_public_path__ + "static/Taiwan-6cf59d9f638e9ced53afa0183da30601.png";